import React from 'react';
import { Lock, Crown, Sparkles, Check } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const PremiumLock = ({ featureName, onUpgrade }) => {
  const { t } = useTranslation();
  
  const quickFeatures = [
    t('premium.feature1', 'Personalized Wealth Ladder roadmap'),
    t('premium.feature2', 'Advanced budgeting & spending insights'),
    t('premium.feature3', 'Cash flow forecasting & projections'),
  ];

  return (
    <div className="relative w-full min-h-[400px] flex items-center justify-center">
      {/* Dark gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 opacity-95 rounded-xl"></div>
      
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
        backgroundSize: '32px 32px'
      }}></div>
      
      {/* Lock overlay content */}
      <div className="relative z-10 text-center p-8 max-w-md">
        {/* Premium icon */}
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-6"
          style={{
            background: 'linear-gradient(135deg, #D4A84B 0%, #F5D98A 50%, #D4A84B 100%)',
          }}
        >
          <Lock className="w-8 h-8 text-gray-900" />
        </div>
        
        <h3 className="text-xl font-semibold text-white mb-2">
          {t('premiumLock.premiumFeature', 'Premium Feature')}
        </h3>
        
        <p className="text-gray-300 mb-1 text-sm">
          <span className="font-medium text-amber-400">{featureName}</span> {t('premiumLock.isPremium', 'is available with Premium.')}
        </p>
        
        <p className="text-gray-500 text-sm mb-6">
          {t('premiumLock.unlockAccess', 'Unlock access to all advanced tools and insights.')}
        </p>
        
        {/* Quick feature list */}
        <div className="text-left space-y-2 mb-6 bg-gray-800/50 rounded-lg p-4">
          {quickFeatures.map((feature, index) => (
            <div key={index} className="flex items-center gap-2">
              <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" />
              <span className="text-gray-300 text-sm">{feature}</span>
            </div>
          ))}
        </div>
        
        {/* Upgrade button */}
        <Button 
          onClick={onUpgrade}
          className="px-8 py-3 rounded-xl font-semibold text-black shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200"
          style={{ 
            background: 'linear-gradient(135deg, #D4A84B 0%, #F5D98A 50%, #D4A84B 100%)',
          }}
        >
          {t('premium.unlockPremium', 'Unlock Premium')}
        </Button>
        
        <p className="text-xs text-gray-500 mt-3">
          {t('premiumLock.startingAt', 'Starting at $9.99/month')} • {t('premium.cancelAnytime', 'Cancel anytime')}
        </p>
      </div>
    </div>
  );
};

export default PremiumLock;
